import { render, staticRenderFns } from "./headerMenu.vue?vue&type=template&id=04c91f15&scoped=true&"
import script from "./headerMenu.vue?vue&type=script&lang=js&"
export * from "./headerMenu.vue?vue&type=script&lang=js&"
import style0 from "./headerMenu.vue?vue&type=style&index=0&id=04c91f15&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c91f15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c91f15')) {
      api.createRecord('04c91f15', component.options)
    } else {
      api.reload('04c91f15', component.options)
    }
    module.hot.accept("./headerMenu.vue?vue&type=template&id=04c91f15&scoped=true&", function () {
      api.rerender('04c91f15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/rosseti/headerMenu.vue"
export default component.exports